import apiClient from "./client";

export const getMetalFrames = async ({ language = "en", frameType } = {}) => {
  const params = { language };
  if (frameType) params.frameType = frameType;
  const response = await apiClient.get("/metal-frames", { params });
  return response.data;
};

export const getMetalFrameById = async ({ id, language = "en" }) => {
  const response = await apiClient.get(`/metal-frames/${id}`, {
    params: { language },
  });
  return response.data;
};
